import React from 'react';
import { STATUS_META, fmtEuro, effectiveStatus } from './paymentsShared';

const fmtShortDate = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', yy: undefined, year: '2-digit' });
};

const dateForStatus = (n) => {
  const st = n.status;
  if (st === 'incassato') return n.paid_at;
  if (st === 'fatturato') return n.invoiced_at || n.invoice_date;
  if (st === 'da_fatturare') return n.unlocked_at;
  return null; // non_sbloccato → nessuna data inventata
};

const Node = ({ n }) => {
  const meta = STATUS_META[effectiveStatus(n)] || STATUS_META.da_fatturare;
  const dt = fmtShortDate(dateForStatus(n));
  return (
    <div className="flex flex-col items-center min-w-[92px]" data-testid="timeline-node" title={`${n.name} · ${meta.label} · netto ${fmtEuro(n.amount_net ?? n.amount)} · IVA ${fmtEuro(n.vat_amount)} · lordo ${fmtEuro(n.amount_gross ?? n.amount)}`}>
      <div className={`w-3.5 h-3.5 rounded-full ${meta.dot} ring-2 ring-white`} />
      <div className="text-[10px] font-medium text-[#3C3C3C] mt-1 text-center leading-tight truncate max-w-[92px]">{n.name}</div>
      {n.percentage != null && <div className="text-[10px] text-[#a3a3a3]">{n.percentage}%</div>}
      <div className={`text-[10px] font-semibold ${meta.text}`}>{fmtEuro(n.amount_net ?? n.amount)}</div>
      {dt && <div className="text-[9px] text-[#a3a3a3]">{dt}</div>}
    </div>
  );
};

// nodes: array già ordinato di {name, percentage, amount/amount_gross, status, paid_at, invoiced_at, invoice_date, unlocked_at, action_required}
export const PaymentTimeline = ({ nodes }) => {
  if (!nodes || nodes.length === 0) {
    return <div className="text-xs text-[#a3a3a3] py-2">Nessun flusso per questa categoria</div>;
  }
  return (
    <div className="flex items-start gap-1 overflow-x-auto pb-1" data-testid="payment-timeline">
      {nodes.map((n, i) => (
        <React.Fragment key={n.id || i}>
          <Node n={n} />
          {i < nodes.length - 1 && <div className="h-3.5 flex items-center mt-0"><div className="w-6 h-px bg-slate-300 mt-3.5" /></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PaymentTimeline;
